import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

/**
 * Footer Component
 */
export class FooterComponent implements OnInit {
  showWhatsAppOptions: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  /**
  * SidebarHide modal
  * @param content modal content
  */
   sidebarShow() {
    document.getElementById('demo-switcher')?.classList.add('show');
    document.querySelector('.vertical-overlay')?.classList.add('show');
  }

  /**
  * SidebarHide modal
  * @param content modal content
  */
  SidebarHide() {
    document.getElementById('demo-switcher')?.classList.remove('show');
    document.querySelector('.vertical-overlay')?.classList.remove('show');
  }



  toggleWhatsAppOptions(): void {
    this.showWhatsAppOptions = !this.showWhatsAppOptions;
  }

  redirectToWhatsApp(message: string): void {
    const phoneNumber = '22796892740';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

}
